import { render } from "./NotificationSettingsEtaGrid.vue?vue&type=template&id=0a6c84c0"
import script from "./NotificationSettingsEtaGrid.vue?vue&type=script&lang=js"
export * from "./NotificationSettingsEtaGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__